export enum FnLoaderType {
    MANUAL = 'MANUAL',
    AUTO = 'AUTO'
}
